{
  "ConferenceParticipation": "Conference participation",
  "EducationalOperations": "Educational operations",
  "FeasibilityStudy": "Feasibility study",
  "InnovationCooperation": "Innovation cooperation",
  "InnovationCounseling": "Innovation counseling",
  "InternationalMarketPositionsDevelopment": "International market positions development",
  "InternationalMarketsKnowledge": "International markets knowledge",
  "Investments": "Investments",
  "OperationApplication": "Operation application",
  "Training": "Training"
}
